var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMexicoFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "country-flags",
    clipPath: "url(#clip0_2145_823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0004 12.0002C24.0004 7.24266 21.2317 3.13192 17.2178 1.19092V22.8094C21.2317 20.8685 24.0004 16.7577 24.0004 12.0002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 12.0002C0 16.7577 2.76867 20.8685 6.78263 22.8095V1.19092C2.76867 3.13192 0 7.24267 0 12.0002Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.86914 12C8.86914 13.7289 10.2707 15.1305 11.9996 15.1305C13.7285 15.1305 15.13 13.7289 15.13 12V10.9565H8.86914V12Z",
    fill: "#6DA544"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.174 9.91311H13.0436C13.0436 9.33683 12.5764 8.86963 12.0001 8.86963C11.4238 8.86963 10.9566 9.33683 10.9566 9.91311H7.82617C7.82617 10.4894 8.32816 10.9566 8.90439 10.9566H8.86966C8.86966 11.5329 9.33681 12.0001 9.91314 12.0001C9.91314 12.5764 10.3803 13.0436 10.9566 13.0436H13.0436C13.6199 13.0436 14.0871 12.5764 14.0871 12.0001C14.6634 12.0001 15.1306 11.5329 15.1306 10.9566H15.0958C15.6721 10.9566 16.174 10.4894 16.174 9.91311Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2145_823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexicoFlag);
export default __webpack_public_path__ + "static/media/mexicoFlag.0db76f54d3a80cd355bdbd4e8ab7cfb1.svg";
export { ForwardRef as ReactComponent };